// extracted by mini-css-extract-plugin
export var item = "FaqList-module--item--3zVed";
export var question = "FaqList-module--question--3X19m";
export var answer = "FaqList-module--answer--39tdU";
export var arrow = "FaqList-module--arrow--1uLF8";
export var open = "FaqList-module--open--2f7b5";